import { Club, ClubCapability, ClubStatus } from "api/clubs";
import { SubscriptionStatus, SubscriptionType } from "api/company";
import { SportForm } from "api/courts";
import { request } from "utils/api";

const getClubs = (data: {
    query?: string,
    clubStatus?: ClubStatus,
    mainSportForm?: SportForm,
    capabilities?: ClubCapability[],
    sportForm?: SportForm,
    subscriptionStatus?: SubscriptionStatus | "no-subscription",
    subscriptionType?: SubscriptionType,
    clubId?: string,
    limit?: number,
    offset?: number,
}) => request<{ data: Club[], totalCount: number }>({
    data,
    endpoint: "root/clubs",
    method: "get",
});

export default getClubs;
